export const COUNTRIES_MAP = {
  AU: { code: '61', name: 'Australia' },
  US: { code: '1', name: 'USA' },
  CA: { code: '1', name: 'Canada' },
  IN: { code: '91', name: 'India' },
  TH: { code: '66', name: 'Thailand' },
  AE: {
    code: '971',
    name: 'United Ar',
  },
  AF: { code: '93', name: 'Afghanistan' },
  AX: { code: '358', name: 'Aland Islands' },
  AL: { code: '355', name: 'Albania' },
  DZ: { code: '213', name: 'Algeria' },
  AD: { code: '376', name: 'Andorra' },
  AO: { code: '244', name: 'Angola' },
  AI: { code: '1264', name: 'Anguilla' },
  AG: { code: '1268', name: 'Antigua and Barbuda' },
  AR: { code: '54', name: 'Argentina' },
  AM: { code: '374', name: 'Armenia' },
  AW: { code: '297', name: 'Aruba' },
  AT: { code: '43', name: 'Austria' },
  AZ: { code: '994', name: 'Azerbaijan' },
  BS: { code: '1242', name: 'Bahamas' },
  BH: { code: '973', name: 'Bahrain' },
  BD: { code: '880', name: 'Bangladesh' },
  BY: { code: '375', name: 'Belarus' },
  BE: { code: '32', name: 'Belgium' },
  BZ: { code: '501', name: 'Belize' },
  BJ: { code: '229', name: 'Benin' },
  BM: { code: '1441', name: 'Bermuda' },
  BT: { code: '975', name: 'Bhutan' },
  BO: { code: '591', name: 'Bolivia, Plurinational State of bolivia' },
  BA: { code: '387', name: 'Bosnia and Herzegovina' },
  BW: { code: '267', name: 'Botswana' },
  BV: { code: '47', name: 'Bouvet Island' },
  BR: { code: '55', name: 'Brazil' },
  BN: { code: '673', name: 'Brunei Darussalam' },
  BG: { code: '359', name: 'Bulgaria' },
  BF: { code: '226', name: 'Burkina Faso' },
  BI: { code: '257', name: 'Burundi' },
  KH: { code: '855', name: 'Cambodia' },
  CM: { code: '237', name: 'Cameroon' },
  CV: { code: '238', name: 'Cape Verde' },
  CF: { code: '236', name: 'Central African Republic' },
  TD: { code: '235', name: 'Chad' },
  CL: { code: '56', name: 'Chile' },
  CN: { code: '86', name: 'China' },
  CX: { code: '61', name: 'Christmas Island' },
  CC: { code: '61', name: 'Cocos Keeling Islands' },
  CO: { code: '57', name: 'Colombia' },
  KM: { code: '269', name: 'Comoros' },
  CG: { code: '242', name: 'Congo' },
  CD: { code: '243', name: 'Congo, The Democratic Republic of the Congo' },
  CK: { code: '682', name: 'Cook Islands' },
  CR: { code: '506', name: 'Costa Rica' },
  CI: { code: '225', name: "Cote d'Ivoire" },
  HR: { code: '385', name: 'Croatia' },
  CU: { code: '53', name: 'Cuba' },
  CY: { code: '357', name: 'Cyprus' },
  CZ: { code: '420', name: 'Czech Republic' },
  DK: { code: '45', name: 'Denmark' },
  DJ: { code: '253', name: 'Djibouti' },
  EC: { code: '593', name: 'Ecuador' },
  EG: { code: '20', name: 'Egypt' },
  SV: { code: '503', name: 'El Salvador' },
  GQ: { code: '240', name: 'Equatorial Guinea' },
  ER: { code: '291', name: 'Eritrea' },
  EE: { code: '372', name: 'Estonia' },
  ET: { code: '251', name: 'Ethiopia' },
  FK: { code: '500', name: 'Falkland Islands Malvinas' },
  FO: { code: '298', name: 'Faroe Islands' },
  FJ: { code: '679', name: 'Fiji' },
  FI: { code: '358', name: 'Finland' },
  FR: { code: '33', name: 'France' },
  GF: { code: '594', name: 'French Guiana' },
  PF: { code: '689', name: 'French Polynesia' },
  TF: { code: '262', name: 'French Southern Territories' },
  GA: { code: '241', name: 'Gabon' },
  GM: { code: '220', name: 'Gambia' },
  GE: { code: '995', name: 'Georgia' },
  DE: { code: '49', name: 'Germany' },
  GH: { code: '233', name: 'Ghana' },
  GI: { code: '350', name: 'Gibraltar' },
  GR: { code: '30', name: 'Greece' },
  GU: { code: '1671', name: 'Guam' },
  GT: { code: '502', name: 'Guatemala' },
  GG: { code: '44', name: 'Guernsey' },
  GN: { code: '224', name: 'Guinea' },
  GW: { code: '245', name: 'Guinea-Bissau' },
  GY: { code: '592', name: 'Guyana' },
  HT: { code: '509', name: 'Haiti' },
  HM: { code: '672', name: 'Heard Island and Mcdonald Islands' },
  HN: { code: '504', name: 'Honduras' },
  HK: { code: '852', name: 'Hong Kong' },
  HU: { code: '36', name: 'Hungary' },
  IS: { code: '354', name: 'Iceland' },
  ID: { code: '62', name: 'Indonesia' },
  IR: { code: '98', name: 'Iran, Islamic Republic of Persian Gulf' },
  IQ: { code: '964', name: 'Iraq' },
  IE: { code: '353', name: 'Ireland' },
  IM: { code: '44', name: 'Isle of Man' },
  IL: { code: '972', name: 'Israel' },
  IT: { code: '39', name: 'Italy' },
  JP: { code: '81', name: 'Japan' },
  JE: { code: '44', name: 'Jersey' },
  JO: { code: '962', name: 'Jordan' },
  KZ: { code: '7', iame: 'Kazakhstan' },
  KE: { code: '254', name: 'Kenya' },
  KR: { code: '82', name: 'Korea, Republic of South Korea' },
  KW: { code: '965', name: 'Kuwait' },
  KG: { code: '996', name: 'Kyrgyzstan' },
  LA: { code: '856', name: 'Laos' },
  LV: { code: '371', name: 'Latvia' },
  LB: { code: '961', name: 'Lebanon' },
  LS: { code: '266', name: 'Lesotho' },
  LR: { code: '231', name: 'Liberia' },
  LY: { code: '218', name: 'Libyan Arab Jamahiriya' },
  LI: { code: '423', name: 'Liechtenstein' },
  LT: { code: '370', name: 'Lithuania' },
  LU: { code: '352', name: 'Luxembourg' },
  MO: { code: '853', name: 'Macao' },
  MK: { code: '389', name: 'Macedonia' },
  MG: { code: '261', name: 'Madagascar' },
  MW: { code: '265', name: 'Malawi' },
  MY: { code: '60', name: 'Malaysia' },
  MV: { code: '960', name: 'Maldives' },
  ML: { code: '223', name: 'Mali' },
  MT: { code: '356', name: 'Malta' },
  MR: { code: '222', name: 'Mauritania' },
  MU: { code: '230', name: 'Mauritius' },
  YT: { code: '262', name: 'Mayotte' },
  MX: { code: '52', name: 'Mexico' },
  MD: { code: '373', name: 'Moldova' },
  MC: { code: '377', name: 'Monaco' },
  MN: { code: '976', name: 'Mongolia' },
  ME: { code: '382', name: 'Montenegro' },
  MA: { code: '212', name: 'Morocco' },
  MZ: { code: '258', name: 'Mozambique' },
  MM: { code: '95', name: 'Myanmar' },
  NA: { code: '264', name: 'Namibia' },
  NP: { code: '977', name: 'Nepal' },
  NL: { code: '31', name: 'Netherlands' },
  NC: { code: '687', name: 'New Caledonia' },
  NZ: { code: '64', name: 'New Zealand' },
  NI: { code: '505', name: 'Nicaragua' },
  NE: { code: '227', name: 'Niger' },
  NG: { code: '234', name: 'Nigeria' },
  NF: { code: '672', name: 'Norfolk Island' },
  NO: { code: '47', name: 'Norway' },
  OM: { code: '968', name: 'Oman' },
  PK: { code: '92', name: 'Pakistan' },
  PS: { code: '970', name: 'Palestinian Territory, Occupied' },
  PA: { code: '507', name: 'Panama' },
  PG: { code: '675', name: 'Papua New Guinea' },
  PY: { code: '595', name: 'Paraguay' },
  PE: { code: '51', name: 'Peru' },
  PH: { code: '63', name: 'Philippines' },
  PN: { code: '64', name: 'Pitcairn' },
  PL: { code: '48', name: 'Poland' },
  PT: { code: '351', name: 'Portugal' },
  QA: { code: '974', name: 'Qatar' },
  RE: { code: '262', name: 'Reunion' },
  RO: { code: '40', name: 'Romania' },
  RU: { code: '7', name: 'Russia' },
  RW: { code: '250', name: 'Rwanda' },
  BL: { code: '590', name: 'Saint Barthelemy' },
  MF: { code: '590', name: 'Saint Martin' },
  SM: { code: '378', name: 'San Marino' },
  ST: { code: '239', name: 'Sao Tome and Principe' },
  SA: { code: '966', name: 'Saudi Arabia' },
  SN: { code: '221', name: 'Senegal' },
  RS: { code: '381', name: 'Serbia' },
  SC: { code: '248', name: 'Seychelles' },
  SL: { code: '232', name: 'Sierra Leone' },
  SG: { code: '65', name: 'Singapore' },
  SK: { code: '421', name: 'Slovakia' },
  SI: { code: '386', name: 'Slovenia' },
  SO: { code: '252', name: 'Somalia' },
  ZA: { code: '27', name: 'South Africa' },
  SS: { code: '211', name: 'South Sudan' },
  ES: { code: '34', name: 'Spain' },
  LK: { code: '94', name: 'Sri Lanka' },
  SD: { code: '249', name: 'Sudan' },
  SR: { code: '597', name: 'Suriname' },
  SJ: { code: '47', name: 'Svalbard and Jan Mayen' },
  SZ: { code: '268', name: 'Swaziland' },
  SE: { code: '46', name: 'Sweden' },
  CH: { code: '41', name: 'Switzerland' },
  SY: { code: '963', name: 'Syrian Arab Republic' },
  TW: { code: '886', name: 'Taiwan' },
  TJ: { code: '992', name: 'Tajikistan' },
  TZ: { code: '255', name: 'Tanzania, United Republic of Tanzania' },
  TL: { code: '670', name: 'Timor-Leste' },
  TG: { code: '228', name: 'Togo' },
  TO: { code: '676', name: 'Tonga' },
  TN: { code: '216', name: 'Tunisia' },
  TR: { code: '90', name: 'Turkey' },
  TM: { code: '993', name: 'Turkmenistan' },
  UG: { code: '256', name: 'Uganda' },
  UA: { code: '380', name: 'Ukraine' },
  GB: { code: '44', name: 'United Kingdom' },
  UY: { code: '598', name: 'Uruguay' },
  UZ: { code: '998', name: 'Uzbekistan' },
  VU: { code: '678', name: 'Vanuatu' },
  VE: { code: '58', name: 'Venezuela, Bolivarian Republic of Venezuela' },
  VN: { code: '84', name: 'Vietnam' },
  YE: { code: '967', name: 'Yemen' },
  ZM: { code: '260', name: 'Zambia' },
  ZW: { code: '263', name: 'Zimbabwe' },
};
